import React from "react";
import { Flag, ClipboardList, Compass } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "@/contexts/LanguageContext";

interface HeroSectionProps {
  showCreate: boolean;
  setShowCreate: (show: boolean) => void;
}

const HeroSection = ({ showCreate, setShowCreate }: HeroSectionProps) => {
  const navigate = useNavigate();
  const { t } = useLanguage();

  return (
    <header className="ed-section-navy font-body relative overflow-hidden text-white">
      {/* Aurora blurred orbs */}
      <div className="absolute inset-0 opacity-30 pointer-events-none">
        <div className="ed-aurora-orb ed-aurora-orb--primary top-0 -left-1/4 w-1/2 h-1/2" />
        <div className="ed-aurora-orb ed-aurora-orb--secondary bottom-0 -right-1/4 w-1/2 h-1/2" />
      </div>

      {/* Subtle dot grid */}
      <div className="ed-dot-grid absolute inset-0 opacity-[0.07] pointer-events-none" />

      <div className="relative max-w-5xl mx-auto px-6 pt-24 pb-16 md:pt-32 md:pb-24 text-center">
        <span className="ed-eyebrow-light mb-6">
          Civic Tech · France
        </span>

        <h1 className="font-display text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-extrabold tracking-tight leading-[1.05] mb-6 ed-fade-up">
          {t("hero.title").split(" ").slice(0, -2).join(" ")}{" "}
          <span className="ed-accent-gold">
            {t("hero.title").split(" ").slice(-2).join(" ")}
          </span>
        </h1>

        <p className="text-base sm:text-lg md:text-xl text-slate-300 font-light leading-relaxed max-w-2xl mx-auto mb-4 ed-fade-up ed-fade-up-delay-1">
          {t("hero.subtitle")}
        </p>

        <div className="ed-rule-gold mx-auto mb-8 ed-fade-up ed-fade-up-delay-1" />

        <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center ed-fade-up ed-fade-up-delay-2">
          <button
            onClick={() => setShowCreate(!showCreate)}
            className="ed-btn-gold ed-focus-ring inline-flex items-center gap-2"
          >
            {showCreate ? (
              <>
                <ClipboardList className="h-5 w-5" />
                {t("reports.view")}
              </>
            ) : (
              <>
                <Flag className="h-5 w-5" />
                {t("reports.new")}
              </>
            )}
          </button>
          <button
            onClick={() => navigate("/how-it-works")}
            className="ed-btn-ghost-light ed-focus-ring inline-flex items-center gap-2"
          >
            <Compass className="h-5 w-5" />
            Découvrir la plateforme
          </button>
        </div>
      </div>
    </header>
  );
};

export default HeroSection;
